import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';

import { Order, LineItem } from '../../../types/orders';
import { UiState } from '../types';

import AuthorizeByItems from './AuthorizeByItems';
import AuthorizeError from './AuthorizeError';
import AuthorizeSuccess from './AuthorizeSuccess';
import { OperationResponseError } from '../../types';

interface MatchParams {
    accountId: string;
}

export interface AuthorizeModalProps extends WithTranslation, RouteComponentProps<MatchParams> {
    state: UiState;
    order: Order | undefined;
    dismissModal: () => void;
    authorizeItems: (accountId: string, order: Order, items: LineItem[]) => void;
    error: OperationResponseError | undefined;
}

class AuthorizeModal extends Component<AuthorizeModalProps> {
    componentDidUpdate(prevProps: Readonly<AuthorizeModalProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if (prevProps.location.pathname && prevProps.location.pathname !== this.props.location.pathname) {
            // close modal on (history) navigation
            this.props.dismissModal();
        }
    }

    render() {
        const { state, order, dismissModal, authorizeItems, error } = this.props;
        const accountId = this.props.match.params.accountId;

        if (state === UiState.Inactive) {
            return null;
        }
        if (order && [UiState.Form, UiState.InFlight].includes(state)) {
            return (
                <AuthorizeByItems
                    state={state}
                    order={order}
                    dismissModal={dismissModal}
                    authorizeItems={authorizeItems}
                    accountId={accountId}
                />
            );
        }

        if (order && state === UiState.Success) {
            return <AuthorizeSuccess order={order} dismissModal={dismissModal} />;
        }

        if (state === UiState.Error) {
            return <AuthorizeError order={order} error={error} dismissModal={dismissModal} />;
        }
        return null;
    }
}

export default withTranslation()(AuthorizeModal);
